(() => {
  const translateHeader = (root = document.getElementById('header-group')) => {
    if (!root) return;
    root.querySelectorAll('.menu-list__link-title, .menu-drawer__menu-item-text').forEach((element) => {
      if (element.textContent.trim() === 'Dom') element.textContent = 'Acasă';
    });
  };

  const start = () => {
    const header = document.getElementById('header-group');
    translateHeader(header);
    if (!header) return;

    const observer = new MutationObserver(() => translateHeader(header));
    observer.observe(header, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element && event.target.closest('#header-group')) translateHeader(event.target);
  });
})();
